import React from "react";
import classes from "./Main.module.scss";
import { theme } from "../../../theme/theme";
import { useRecoilValue } from "recoil";
import { userState } from "../../../states/userState";
import HeaderController from "../../main/HeaderController";
import { TableArea } from "../../main/TableArea";
import ScrollButton from "../../uikit/atoms/buttons/ScrollButton";
const Main = () => {
  const user = useRecoilValue(userState);
  return (
    <div
      className={classes.rootContainer}
      style={backgroundColor(user?.mode ?? "lite")}
    >
      <HeaderController />

      <TableArea />
      <ScrollButton />
    </div>
  );
};
const backgroundColor = (mode: string) => {
  return {
    backgroundColor:
      mode === "lite"
        ? theme.palette.liteColor.backColor.main //間違いではない。色合いを考慮してdarkColorを指定している
        : theme.palette.darkColor.backColor.main,
  };
};
export default Main;
